import CardChartTotal from '@/components/ui/card-wrapper/CardChartTotal';
import ReactApexChart from 'react-apexcharts';
import dayjs from 'dayjs';
// import { fillMissingHours } from './util';
import { ApexOptions } from 'apexcharts';
type ServerlessGpuOverviewMetricsTasksProps = {
  data: {
    date: number;
    value: number;
  }[];
  sumTotal: number;
};

const ServerlessGpuOverviewMetricsTasks = ({
  data,
  sumTotal,
}: ServerlessGpuOverviewMetricsTasksProps) => {
  const result = data;

  const options: ApexOptions = {
    chart: {
      type: 'line',
      height: 250,
      toolbar: {
        show: true,
        tools: {
          download: false,
        },
      },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: false,
      },
      tickAmount: 2,
    },
    colors: ['hsl(var(--success))'],
    legend: {
      markers: {
        shape: 'circle',
        size: 12,
      },
      position: 'bottom',
      horizontalAlign: 'center',
    },
    tooltip: {
      x: {
        formatter: (value: number) => dayjs(value).format('DD MMM, HH:mm'),
      },
    },
  };

  const series = [
    {
      name: 'Total',
      data: result.map((item) => [item.date, item.value]),
    },
  ];

  return (
    <CardChartTotal
      title="Endpoint Requests"
      description="Showing total endpoint requests for past 24 hours"
      total={sumTotal.toLocaleString() || '0'}
    >
      <div className="h-[250px] w-full">
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={250}
        />
      </div>
    </CardChartTotal>
  );
};

export default ServerlessGpuOverviewMetricsTasks;
